// src/components/game/GamePaused.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faStop } from '@fortawesome/free-solid-svg-icons';

const GamePaused = ({ onResume, onEndGame }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm z-10 animate-[fadeIn_0.3s_ease-in]">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-md w-full mx-4 border border-gray-200">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">Game Paused</h2>
        
        <div className="mb-6 p-4 rounded-lg border border-gray-200 bg-gray-50">
          <p className="text-gray-600">Paused. Ready when you are.</p>
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <button 
            className="px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 
                       transition-colors shadow-sm font-medium
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
                       flex items-center justify-center"
            onClick={onResume}
          >
            <FontAwesomeIcon icon={faPlay} className="w-4 h-4 mr-2" />
            Resume
          </button>
          
          <button 
            className="px-4 py-3 bg-gray-100 text-gray-800 border border-gray-300 rounded-lg
                       hover:bg-gray-200 transition-colors shadow-sm font-medium
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500
                       flex items-center justify-center"
            onClick={onEndGame}
          >
            <FontAwesomeIcon icon={faStop} className="w-4 h-4 mr-2" />
            End Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default GamePaused;